// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Table_wrapper__3J4Vg","box":"Table_box__1Pbn5","newStyle":"Table_newStyle__2bQVo","dropdownOverlay":"Table_dropdownOverlay__2v129"};